// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wcqt","toggleWrap":"styles_toggleWrap__3da7j","content":"styles_content__3eFEU","selectAreaCode":"styles_selectAreaCode__TIQS5"};